import React, { useEffect, useRef } from "react";
import {
  DEFAULT_REDIRECT_URL,
  STORAGE_CONSTANT,
  URLS,
} from "configs/constants";
import ProtectedRoute from "configs/ProtectedRoute";
import withLayout from "configs/withLayout";
// import { Route } from "react-router-dom";
import { NormalRoute as Route } from "configs/NormalRoute";
import eightAxios from "configs/axiosConfig";
import dashboardRoutes from "../configs/dashboardRoutes";

export const activeRoute = (routeName) => {
  return location.pathname === routeName;
};

export const activeSubItemRoute = (routeName) => {
  return location.pathname.includes(routeName);
};

// If the url of the page is `/attendance/record`, then this function returns `/attendance`
export const getParentSidebarUrl = (url) => {
  let subUrls = url.split("/");
  if (subUrls.length < 3) return url;
  return subUrls.slice(0, 2).join("/");
};

// Route utils
const userModules = JSON.parse(localStorage.getItem(STORAGE_CONSTANT.MODULES));

export const getModulesList = () => {
  let updatedModules = JSON.parse(
    localStorage.getItem(STORAGE_CONSTANT.NEW_MODULES)
  );
  if (updatedModules && typeof updatedModules === "object") {
    return Object.keys(updatedModules);
  }
  return undefined;
};

export const checkRoutePermission = (modulesInReverseOrder = []) => {
  let currentRouteModule = undefined;
  for (let i = 0; i < modulesInReverseOrder.length; ++i) {
    if (modulesInReverseOrder[i]) {
      currentRouteModule = modulesInReverseOrder[i];
      break;
    }
  }
  if (!currentRouteModule) return true;
  if (!userModules) return false;
  let updatedModules = getModulesList();
  return updatedModules.includes(currentRouteModule);
};

export const getMainRoutes = (routes) => {
  return routes.map((route, index) => {
    let hasPermission = checkRoutePermission([route.module]);
    if (!hasPermission) return null;
    return route.collapsible ? null : route.protected ? (
      <ProtectedRoute
        key={index}
        path={route.path}
        component={withLayout(route.layout, route.component)}
        exact={route.exact}
        permissions={route.permissions}
      />
    ) : (
      <Route
        key={index}
        path={route.path}
        component={withLayout(route.layout, route.component, {
          redirect: true,
        })}
        exact={route.exact}
      />
    );
  });
};

/*
  This function is specific, and can only be used in this App, inside App.js
  As our app has normal route and collapsible routes included in sidebar...
  ...it helps to populate collapsible
 */
export const getCollapsibleRoutes = (index, route) => {
  if (!route.items) return null;
  let RouteType = route.protected ? ProtectedRoute : Route;
  return route.items.map((item, ind) => {
    let hasPermission = checkRoutePermission([item.module, route.module]);
    if (!hasPermission) return null;
    return (
      <RouteType
        key={"#" + index.toString() + ind.toString()}
        path={route.path + item.path}
        component={withLayout(route.layout, item.component)}
        exact={item.exact}
        module={item.module ? item.module : route.module}
      />
    );
  });
};

export const getCollapsibleSubRoutes = (index, route) => {
  if (!route.items) return null;
  let RouteType = route.protected ? ProtectedRoute : Route;
  return route.items.map((item, itemIndex) => {
    if (!item.subItems) return null;
    return item.subItems.map((subItem, subIndex) => {
      let hasPermission = checkRoutePermission([
        subItem.module,
        item.module,
        route.module,
      ]);
      if (!hasPermission) return null;
      return (
        <RouteType
          key={
            "#" + index.toString() + itemIndex.toString() + subIndex.toString()
          }
          path={route.path + item.path + subItem.path}
          component={withLayout(route.layout, subItem.component)}
          module={
            subItem.module
              ? subItem.module
              : item.module
              ? item.module
              : route.module
          }
          exact={subItem.exact}
        />
      );
    });
  });
};

export const saveLoginInfo = async (data) => {
  eightAxios.defaults.headers["Authorization"] = `JWT ${data.token}`;
  localStorage.setItem(STORAGE_CONSTANT.TOKEN, data.token);
  localStorage.setItem(STORAGE_CONSTANT.ID, data.id);
  localStorage.setItem(STORAGE_CONSTANT.USERNAME, data.username);
  localStorage.setItem("email",  JSON.stringify(data.email));

  localStorage.setItem(STORAGE_CONSTANT.MODULES, JSON.stringify(data.modules));
  localStorage.setItem(STORAGE_CONSTANT.ROLES, JSON.stringify(data.roles));
  localStorage.setItem(
    STORAGE_CONSTANT.NEW_MODULES,
    JSON.stringify(data.modules_updated)
  );
};

export const clearLocalStorage = async () => {
  localStorage.clear();
};

export const isObjectEmpty = (obj) => {
  for (let i in obj) return false;
  return true;
};

export const hasSubArray = (master, sub) => {
  return sub.every(((i) => (v) => (i = master.indexOf(v, i) + 1))(0));
};

export const removeDuplicatesFromArray = (mainArray, arrayToRemove) => {
  mainArray = mainArray.filter(function (el) {
    return !arrayToRemove.includes(el);
  });
  return mainArray;
};

export const fetchDataFromApi = (url, callback, paginated, config, errorcallback = (error) => {}) => {
  eightAxios
    .get(url, config)
    .then((response) => {
      if (paginated) {
        callback(response.data.results);
      } 
      else {
        callback(response.data);
      }
    })
    .catch((error) => {
      console.log(url);
      console.error(error);
      errorcallback(error);
    });
};

export function resolveObjectPath(path, obj) {
  if (path) {
    return path.split(".").reduce(function (prev, curr) {
      return prev ? prev[curr] : null;
    }, obj || self);
  }
  return "N/A";
}

export function useInterval(callback, delay) {
  const savedCallback = useRef();
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  useEffect(() => {
    const tick = () => {
      savedCallback.current();
    };
    if (delay !== null) {
      const id = setInterval(tick, delay);
      return () => {
        clearInterval(id);
      };
    }
  }, [callback, delay]);
}

export const redirectToLogin = () => {
  location.href = URLS.LOGIN;
};

export function FormLineBreak() {
  return <div />;
}

export const getRedirectUrl = () => {
  let modules = JSON.parse(localStorage.getItem(STORAGE_CONSTANT.NEW_MODULES));
  if (modules) {
    if (Object.keys(modules).includes("Dashboard")) {
      return DEFAULT_REDIRECT_URL["Dashboard"];
    }
    let firstModule = Object.keys(modules)[0];
    let availableModules = Object.keys(DEFAULT_REDIRECT_URL);
    for (let i = 0; i < availableModules.length; ++i) {
      if (firstModule === availableModules[i])
        return DEFAULT_REDIRECT_URL[firstModule];
    }
  }
  return null;
};

export const removeAllInstances = (arr, item) => {
  for (let i = arr.length; i--; ) {
    if (arr[i] === item) arr.splice(i, 1);
  }
  return arr;
};

export const getAssignedModule = (currentDir) => {
  let module = "";
  let splitUrls = currentDir.split("/");
  removeAllInstances(splitUrls, "");
  let currentRoute;
  if (splitUrls.length === 1) {
    currentRoute = dashboardRoutes.filter((route) => {
      return (
        splitUrls[0] ===
        (route.path ? route.path.replace(/\//g, "") : route.path)
      );
    });
  } else if (splitUrls.length === 2) {
    dashboardRoutes.filter((route) => {
      if (
        splitUrls[0] ===
        (route.path ? route.path.replace(/\//g, "") : route.path)
      ) {
        currentRoute = route.items.filter((item) => {
          return (
            splitUrls[1] ===
            (item.path ? item.path.replace(/\//g, "") : item.path)
          );
        });
      }
    });
  } else if (splitUrls.length > 2) {
    dashboardRoutes.filter((route) => {
      if (
        splitUrls[0] ===
        (route.path ? route.path.replace(/\//g, "") : route.path)
      ) {
        route.items.filter((item) => {
          if (
            splitUrls[1] ===
            (item.path ? item.path.replace(/\//g, "") : item.path)
          ) {
            currentRoute = item.subItems.filter((subItem) => {
              if (subItem.radioInsideTab) {
                return (
                  splitUrls[2] ===
                  (subItem.path
                    ? removeAllInstances(subItem.path.split("/"), "")[0]
                    : subItem.path)
                );
              }
              return (
                splitUrls[2] ===
                (subItem.path ? subItem.path.replace(/\//g, "") : subItem.path)
              );
            });
          }
        });
      }
    });
  }
  module = currentRoute.length
    ? currentRoute[0].module
      ? currentRoute[0].module
      : module
    : module;

  return module;
};

// This function is used to get object from select options
export const getObjectFromCurrentValue = (currentValue, options) => {
  let selectedObj;
  if(options.length<=0){
    selectedObj={value: currentValue, label: currentValue}
    return selectedObj;
  }
  if (currentValue) {
    selectedObj = options.find((obj) => {
      return obj.id ? obj.id === currentValue : obj.value === currentValue;
    });
    return selectedObj;
  }
  return selectedObj;
};

export const getOptionFromCurrentValue = (nameValue,labelValue,options) => {
  let selectedObj;
  if(!options || !options.length){
    selectedObj={value: nameValue, label: labelValue}
    console.log("selectedObj",selectedObj)

    return selectedObj;
  }
  if (nameValue) {
    selectedObj = options.find(x => x.name == nameValue);

    }
    return selectedObj;
  }
    


export const getMultipleObjectsForMultiSelect = (currentValue, options) => {
  if (currentValue && options) {
    return options.filter((option) => currentValue.includes(option.value));
  }
};

// Just a helper function to get name of all available modules/pages
// Won't be needing this again, still don't remove this
export const getModulesName = (routes) => {
  let modules = [];
  routes.forEach((route) => {
    if (route.items && route.items.length) {
      let subModules = { [route.name]: [] };
      route.items.forEach((item) => {
        if (item.subItems && item.subItems.length) {
          item.subItems.forEach((subItem) => {
            if (!subItem.noTab) {
              subModules[route.name].push(subItem.name);
            }
          });
        }
      });
      if (subModules[route.name].length) {
        modules.push(subModules);
      }
    } else {
      modules.push(route.name);
    }
  });
  return modules;
};

export const breakDownModules = (modules) => {
  let modulesBrokenDown = [];
  let moduleList = Object.entries(modules);
  for (let i = 0; i < moduleList.length; ++i) {
    if (moduleList[i].length === 2) {
      if (moduleList[i][1].length) {
        moduleList[i][1].forEach((item) => {
          modulesBrokenDown.push(moduleList[i][0] + "__" + item);
        });
      }
    }
  }
  return modulesBrokenDown;
};

export const convertToObject = (list) => {
  let objToReturn = {};
  for (let i = 0; i < list.length; ++i) {
    if (list[i].length === 2) {
      if (objToReturn[list[i][0]]) {
        objToReturn[list[i][0]].push(list[i][1]);
      } else {
        Object.assign(objToReturn, { [list[i][0]]: [list[i][1]] });
      }
    }
  }
  return objToReturn;
};

export const buildUpModules = (permissionList) => {
  let temp = permissionList;
  for (let i = 0; i < temp.length; ++i) {
    temp[i] = temp[i].split("__");
  }
  return convertToObject(temp);
};

export const mapOldOptionsToNewOptions = (oldOptions) => {
  if (oldOptions && oldOptions.length) {
    return oldOptions.map((oldOption) => ({
      value: oldOption.value ? oldOption.value : oldOption.id,
      label: oldOption.label ? oldOption.label : (oldOption.name ?? "").toUpperCase(),
    }));
  }
  return [];
};

export const hashCode = (s) =>
  s.split("").reduce((a, b) => {
    a = (a << 5) - a + b.charCodeAt(0);
    return a & a;
  }, 0);

export const usePrevious = (value) => {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  }, [value]);

  return ref.current;
};